module.exports = __webpack_public_path__ + "img/othermiscell.3deb40f4.png";